import { render } from "./UserCalendarItem.vue?vue&type=template&id=f1159358"
import script from "./UserCalendarItem.vue?vue&type=script&lang=js"
export * from "./UserCalendarItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__